import { Outlet } from "react-router-dom";

import { FilterItemProvider } from "./filter-item/filter-item.context";
import './item.scss';

export function Item() {
  return (
    <div id="ShellItem" className="item">
       <FilterItemProvider>
        <Outlet />
      </FilterItemProvider>
    </div>
  );
}

export default Item;
